// src/pages/settings/forms/builderDrawer/elements/SortableItem.tsx
import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { FormElement } from "../../../../../../api/formApi";
import { Button } from "antd";
import { DeleteOutlined, MenuOutlined } from "@ant-design/icons";

export const SortableItem: React.FC<{
	field: FormElement;
	children: React.ReactNode;
	onDeleteField: (fieldId: string | number) => void;
}> = ({ field, children, onDeleteField }) => {
	const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
		id: field.id,
		data: { from: "canvas" },
	});

	const style: React.CSSProperties = {
		transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
		transition: transition || "transform 200ms cubic-bezier(0.4, 0, 0.2, 1)",
		opacity: isDragging ? 0.6 : 1,
	};

	return (
		<div ref={setNodeRef} style={style} {...attributes}>
			<div
				style={{
					background: "var(--mg-bg-elevated)",
					border: "1px solid var(--mg-border)",
					borderRadius: 8,
					padding: 12,
					marginBottom: 12,
					boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
					transition: "box-shadow 0.2s",
				}}
				onMouseEnter={(e) => {
					e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
				}}
				onMouseLeave={(e) => {
					e.currentTarget.style.boxShadow = "0 1px 2px rgba(0,0,0,0.05)";
				}}
			>
				<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
					<div style={{ display: "flex", alignItems: "center", gap: 8 }}>
						<div
							{...listeners}
							style={{
								cursor: "grab",
								padding: 4,
								borderRadius: 4,
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								transition: "background 0.2s",
							}}
							onMouseEnter={(e) => {
								e.currentTarget.style.background = "var(--mg-bg-subtle)";
							}}
							onMouseLeave={(e) => {
								e.currentTarget.style.background = "transparent";
							}}
						>
							<MenuOutlined style={{ fontSize: 12, color: "var(--mg-text-secondary)" }} />
						</div>
					</div>
					<Button type="text" danger icon={<DeleteOutlined />} onClick={() => onDeleteField(field.id)} size="small" style={{ width: 24, height: 24, minWidth: 24 }} />
				</div>
				<div style={{ paddingLeft: 24 }}>{children}</div>
			</div>
		</div>
	);
};
